const MQ_BREAKPOINTS = {
    small: 520,
    mobile: 520,
    tablet: 767,
    desktop: 1124,
    'desktop-container': 1600
};

/* eslint-disable import/prefer-default-export */
export {
    MQ_BREAKPOINTS
};
